import AxiosClient from "@/utils/api/axiosClient";

const config = window.rs_wechat;

class AdvertiserApi extends AxiosClient {
  public apiBaseUrl = `${config.base_url}/ads/rates`;

  public getAdvertiserList = async (s: number) => {
    const response = await this.axiosClient.get<AdvertiserListResponse>(
      `${this.apiBaseUrl}`,
      { params: { s } }
    );

    return response.data;
  };
}

export default new AdvertiserApi();
